<template>
  <v-container fluid>
    <v-toolbar>
    <v-tabs>
      <v-tab replace :to="{ name: 'aade-purchases' }">Αγορες</v-tab>
      <v-tab replace :to="{ name: 'aade-sales' }">Πωλησεις</v-tab>
      <v-tab replace :to="{ name: 'aade-client-book' }">Πελατολογιο</v-tab>
      <v-tab replace :to="{ name: 'aade-charts' }">Γραφήματα</v-tab>
    </v-tabs>
    <v-spacer/>
    <v-btn
      color="primary"
      dark
      class="mb-2"
      @click="fetchNew"
    >
    Ληψη νεων παραστατικών
    </v-btn>
    </v-toolbar>
    <router-view/>
  </v-container>
</template>

<script>

export default {
  computed: {
  },
  data() {
    return {}
  },
  async created() {
      try {
        //const response = await this.$api.get('/aade/purchases');
        // console.log(response);
        // this.invoices = response.data;
        // this.loading = false;
      } catch (error) {
        // console.error(error);
      }
  },
  methods: {
    fetchNew() {
      this.$api.get('/aade/update').then(function(response) {
        console.log(response);
        var invos = response.data.invoices;
        var own = response.data.own;

        alert("Ελήφθησαν " + invos + " τιμολόγια αγοράς και " + own + " τιμολόγια πωλήσεων.");
      }).catch(function (error) {
        alert(error);
      });
    }
  }
}
</script>
